var vars = {
  colorPrimary: '#475D7A',
  colorPrimary900: '#475D7A',
  colorPrimary800: '#627EA3',
  colorPrimary700: '#7F96B4',
  colorPrimary600: '#B8C5D5',
  colorPrimary500: '#E3E8EE',
  colorPrimary400: '#F1F3F7',
  colorAccent: '#262626',
  colorAccent900: '#262626',
  colorAccent800: '#595959',
  colorAccent700: '#8C8C8C',
  colorAccent600: '#BFBFBF',
  colorAccent500: '#D9D9D9',
  colorAccent400: '#E8E8E8',
  colorAccent300: '#F5F5F5',
  colorAccent200: '#FAFAFA',
  colorBrandResiRed: '#FF585D',
  colorBrandResiNavy: '#475D7A',
  colorBrandResiDeepNavy: '#253746',
  colorBrandResiLightGray: '#E5E1E5',
  colorBrandResiDarkGray: '#434143',
  colorInlineLinks: '#2F7699',
  colorSuccess: '#389E0D',
  colorSuccessAlt: '#237804',
  colorSuccessSurface: '#E1F1D9',
  colorWarning: '#F19953',
  colorWarningAlt: '#B95E06',
  colorWarningSurface: '#FDF8E9',
  colorError: '#CD4631',
  colorError900: '#B82A13',
  colorError800: '#CD4631',
  colorError700: '#DD7C6C',
  colorError600: '#EA9486',
  colorError500: '#FFE7E3',
  colorSurface: '#fff',
  borderRadius1: '1px',
  borderRadius2: '2px',
  borderRadius4: '4px',
  borderRadius6: '6px',
  borderRadius20: '20px',
  fontFamilyHeadings: "Cabin, 'Open Sans', sans-serif",
  fontFamilyBody: "'Open Sans', sans-serif",
  fontSize10: '0.625rem',
  fontSize12: '0.75rem',
  fontSize14: '0.875rem',
  fontSize16: '1rem',
  fontSize18: '1.125rem',
  fontSize24: '1.5rem',
  fontSize32: '2rem',
  fontSize36: '2.25rem',
  fontSize40: '2.5rem',
  shadow1: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  outlinePrimary: '0 0 0 2px #B8C5D5',
  constraintScale: '100%',
  constraintXs: '50px',
  constraintS: '132px',
  constraintM: '355px',
  constraintL: '496px',
  constraintXl: '768px',
  spacingXs: '.25rem',
  spacingS: '.5rem',
  spacingM: '1rem',
  spacingL: '1.5rem',
  spacingXl: '2rem',
  transitionLinear80Ms: '80ms linear',
  transitionEaseinout150Ms: '150ms ease-in-out',
  transitionStandard: '200ms ease',
  breakPointMobileSmall: '320px',
  breakPointMobile: '414px',
  breakPointTablet: '768px',
  breakPointDesktop: '1024px',
  zIndexAppHeader: '1000',
  zIndexTooltip: '1010',
  zIndexToast: '1020',
  zIndexPopupMenu: '1030',
  zIndexModalBackdrop: '1050',
  backgroundColorForInput: '#fff',
  backgroundColorForInputWhenSelected: '#fff',
  backgroundColorForInputWhenDisabled: '#F5F5F5',
  backgroundColorForInputWhenHovered: '#fff',
  backgroundColorForTag: '#E8E8E8',
  backgroundColorForTagWarning: '#F19953',
  backgroundColorForOption: '#fff',
  backgroundColorForOptionWhenSelected: '#E3E8EE',
  backgroundColorForOptionWhenHovered: '#E8E8E8',
  borderColorForInput: '#D9D9D9',
  borderColorForInputWhenFocused: '#627EA3',
  borderColorForInputWhenDisabled: '#D9D9D9',
  borderColorForInputWhenReadonly: '#D9D9D9',
  borderColorForInputWhenError: '#CD4631',
  borderColorForInputWhenWarning: '#F19953',
  borderColorForSelect: '#D9D9D9',
  borderColorForSelectWhenHovered: '#627EA3',
  borderColorForSelectWhenFocused: '#475D7A',
  borderColorForSelectWhenDisabled: '#D9D9D9',
  borderColorForSelectWhenReadonly: '#D9D9D9',
  borderColorForTag: '#BFBFBF',
  borderColorForTagWarning: '#F19953',
  borderColorForTagWhenFocused: '#475D7A',
  borderRadiusForInput: '2px',
  borderRadiusForTag: '2px',
  fontColorForInput: '#595959',
  fontColorForInputWhenDisabled: '#BFBFBF',
  fontColorForInputWhenError: '#CD4631',
  fontColorForInputWhenReadonly: '#8C8C8C',
  fontColorForInputWhenWarning: '#F19953',
  fontColorForSelectWhenHovered: '#475D7A',
  fontColorForTag: '#262626',
  fontColorForTagWhenDisabled: '#BFBFBF',
  fontColorForTextWhenInverted: '#fff',
  fontFamily: "'Open Sans', sans-serif",
  placeholderFontColorForInput: '#BFBFBF',
  fontSizeForInput: '1rem',
  mediumButtonHeight: '2.75rem',
  smallButtonHeight: '1.5625rem',
  smallInputHeight: '1.5625rem',
  meduimInputHeight: '1.875rem',
  largeInputHeight: '2.75rem'
};

export default vars;
//# sourceMappingURL=custom-properties.js.map
